import type { FlexBuyPercentOptions } from './types';
import { FlexBuyAvailableMonths } from './types';

export const flexBuyPercentOptions: FlexBuyPercentOptions = {
    [FlexBuyAvailableMonths.MONTH_66]: [
        { id: '15', label: '15', value: '15' },
        { id: '18', label: '18', value: '18' },
        { id: '21', label: '21', value: '21' }
    ],
    [FlexBuyAvailableMonths.MONTH_75]: [{ id: '15', label: '15', value: '15' }]
};

export const flexBuyTermOptions = [
    {
        id: `${FlexBuyAvailableMonths.MONTH_66}`,
        label: `${FlexBuyAvailableMonths.MONTH_66}`,
        value: `${FlexBuyAvailableMonths.MONTH_66}`
    },
    {
        id: `${FlexBuyAvailableMonths.MONTH_75}`,
        label: `${FlexBuyAvailableMonths.MONTH_75}`,
        value: `${FlexBuyAvailableMonths.MONTH_75}`
    }
];
